import React, { useEffect, useState } from 'react'
import { CButton, CCardBody } from '@coreui/react-pro'
import { Table } from 'antd'
import { useSectionList } from './hooks'
import { ColumnsType } from 'antd/lib/table'
import { SectionType } from './types'
import { path } from '../../../../libs'
import CIcon from '@coreui/icons-react'
import { cilZoom } from '@coreui/icons'

export const SectionList: React.FC = () => {
  const { sectionList, totalSectionList, loading, onChangeSectionList } =
    useSectionList()

  const [orderBy, setOrderBy] = useState('id')
  const [orderDirection, setOrderDirection] = useState('-')
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)

  const handleTableChange = ({
    currentPage,
    currentPageSize,
    currentOrderBy,
    currentOrderDirection,
  }: {
    currentPage?: number
    currentPageSize?: number
    currentOrderBy?: string
    currentOrderDirection?: string
  }) => {
    if (currentPage) {
      setPage(currentPage)
    }
    if (currentPageSize) {
      setPageSize(currentPageSize)
    }
    if (currentOrderBy) {
      setOrderBy(currentOrderBy)
    }
    if (currentOrderDirection) {
      if (currentOrderDirection == 'descend') {
        setOrderDirection('-')
      } else {
        setOrderDirection('')
      }
    }
  }

  useEffect(() => {
    onChangeSectionList({
      limit: pageSize,
      page: page,
      orderBy: orderBy,
      orderDirection: orderDirection,
    })
  }, [pageSize, page, orderBy, orderDirection])

  const columns: ColumnsType<SectionType> = [
    {
      title: 'ID',
      dataIndex: 'id',
      sorter: (a, b) => Number(a.id) - Number(b.id),
      defaultSortOrder: 'descend',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: true,
    },
    {
      title: 'Actions',
      fixed: 'right',
      width: 100,
      render: (item) => {
        return (
          <>
            <CButton
              color="secondary"
              className="me-2"
              title="View"
              href={path.finSystem.sections.edit(item.id)}
            >
              <CIcon icon={cilZoom} />
            </CButton>
          </>
        )
      },
    },
  ]

  return (
    <CCardBody>
      <CButton
        color="primary"
        className="mb-2"
        href={path.finSystem.sections.create()}
      >
        Create section
      </CButton>
      <Table
        dataSource={sectionList}
        bordered={true}
        scroll={{ x: true }}
        loading={loading}
        rowKey="budgetItemListId"
        columns={columns}
        pagination={{
          showSizeChanger: true,
          total: totalSectionList,
        }}
        onChange={(pagination, sorter, extra) =>
          handleTableChange({
            //@ts-ignore
            currentPage: pagination.current, //@ts-ignore
            currentPageSize: pagination.pageSize, //@ts-ignore
            currentOrderDirection: sorter.order, //@ts-ignore
            currentOrderBy: sorter.field,
          })
        }
      ></Table>
    </CCardBody>
  )
}
